import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorComponent } from './component/author/author.component';
import { BashengComponent } from './component/basheng/basheng.component';
import { BookComponent } from './component/book/book.component';
import { HallOfFameComponent } from './component/hall-of-fame/hall-of-fame.component';
import { HomeComponent } from './component/home/home.component';
import { LibraryComponent } from './component/library/library.component';
import { MuseumComponent } from './component/museum/museum.component';
import { OvooComponent } from './component/ovoo/ovoo.component';
import { ProfileComponent } from './component/profile/profile.component';
import { ScriptComponent } from './component/script/script.component';
import { SearchComponent } from './component/search/search.component';
import { VideoComponent } from './component/video/video.component';
import { WriterComponent } from './component/writer/writer.component';

const routes: Routes = [
  {path: '', redirectTo: '/index', pathMatch: 'full'},
  {path: 'index', component: HomeComponent},
  {path: 'library', component: LibraryComponent},
  {path: 'museum', component: MuseumComponent},
  {path: 'hall-of-fame', component: HallOfFameComponent},
  {path: 'writer', component: WriterComponent},
  {path: 'ovoo', component: OvooComponent},
  {path: 'search', component: SearchComponent},
  {path: 'book/:id', component: BookComponent},
  {path: 'video/:id', component: VideoComponent},
  {path: 'profile/:id', component: ProfileComponent},
  {path: 'author/:id', component: AuthorComponent},
  {path: 'chubanlishi', component: ScriptComponent},
  {path: 'zilishi', component: ScriptComponent},
  {path: 'newspaper', component: ScriptComponent},
  {path: 'basheng', component: BashengComponent},
  {path: 'script', component: ScriptComponent},


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
